module.exports = __webpack_public_path__ + "img/logo_fr.b95e58e3.png";